"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var SupportTicketLink_1 = __importDefault(require("./SupportTicketLink"));

var DefaultNoContentMessage = function (_a) {
  var isPwcUser = _a.isPwcUser;

  var getPwcUserMessage = function () {
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: ["Please try again later. If the issue continues, please", ' ', (0, jsx_runtime_1.jsx)(SupportTicketLink_1.default, {}, void 0), " for this issue"]
    }, void 0);
  };

  var getClientMessage = function () {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
      children: "Please try again later. If the issue continues, please contact the Engagement Lead or Engagement Manager"
    }, void 0);
  };

  return (0, jsx_runtime_1.jsxs)("div", __assign({
    "data-testid": "unable-to-load-data-default-message",
    className: "content-section"
  }, {
    children: [isPwcUser && getPwcUserMessage(), !isPwcUser && getClientMessage()]
  }), void 0);
};

exports.default = DefaultNoContentMessage;